import '../styles/login-identity.css'

export default function AuthBrand() {
  return (
    <div className="login-identity">
      <img className="login-identity-symbol" src="/ff-sidebar-monogram.svg" alt="FF" width="56" height="56" />
      <span className="login-identity-name">Controle Financeiro</span>
    </div>
  )
}
